var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tags.length > 0)?_c('div',{staticClass:"tags"},_vm._l((_vm.tags),function(tag){return _c('router-link',{key:tag,staticClass:"tag",attrs:{"to":'/blog?tag=' + encodeURI(tag)}},[_vm._v(_vm._s(tag))])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }